import { CLEAR_FLASH_MESSAGE, ADD_FLASH_MESSAGE } from '../actions';

const initialState = [];

export default (state = initialState, action) => {
  switch (action.type) {

    case ADD_FLASH_MESSAGE:
      return state.concat({
        message: action.payload.message,
        level: action.payload.level
      });

    case CLEAR_FLASH_MESSAGE:
      return state.slice(1);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/codes/reducers/flashMessages.js